import { makeSvgIcon } from '../makeSvgIcon'

export const shield = makeSvgIcon(
  <path d="M5 2L2 7C7 9 3 12 3 15C3 20 10 19 12 22C14 19 21 20 21 15C21 12 17 9 22 7L19 2C14 5 10 5 5 2Z" />
)
